import avatar1 from '@public/images/review/review-1.jpg';
import avatar2 from '@public/images/review/review-2.jpg';
import avatar3 from '@public/images/review/review-3.jpg';
import avatar4 from '@public/images/review/review-4.jpg';
import avatar5 from '@public/images/review/review-5.jpg';
import avatar6 from '@public/images/review/review-6.jpg';
import avatar7 from '@public/images/review/review-7.jpg';
import avatar8 from '@public/images/review/review-8.jpg';
import avatar9 from '@public/images/review/review-9.jpg';

export type Testimonial = {
  text: string;
  imageSrc: string;
  name: string;
  username: string;
};

/**
 * Real parent reviews, verbatim.
 *
 * Extracted from `home/sections/testimonials.tsx` so the marquee and the bento
 * wall render the SAME nine quotes. They were previously inlined in the
 * marquee, which meant any second presentation had to copy them and would drift
 * the moment a review was edited.
 *
 * Not localised on purpose: these are quotations. Translating a parent's words
 * would misrepresent them, so they display as written in whichever language
 * they were left.
 */
export const testimonials: Testimonial[] = [
  {
    text: "老师们的用心♥耐心♥爱心♥满满的让我的孩子快乐地学习，上学开心，放学开心，这方面快乐的学习环境，能让我的孩子有所进步和慢慢的懂事了不少，感恩老师们用心教导，您们真的很棒👍👍👍",
    imageSrc: avatar1.src,
    name: "蔡承延",
    username: "@蔡承延",
  },
  {
    text: "Joyee Preschool  的老师们都很棒，很细心💕也很有耐心💕举办活动时也给小朋友们很多惊喜，让孩子们玩得很开心，谢谢老师们的用心，让我的孩子能快乐的成长以学习👍",
    imageSrc: avatar2.src,
    name: "Quek Xiuzhu",
    username: "@quek.xiuzhu",
  },
  {
    text: "一群很棒👍的老师们，很有耐心爱心。很放心两个孩子在这里读书。",
    imageSrc: avatar3.src,
    name: "Eva Ng",
    username: "@evang89",
  },
  {
    text: "卓羿的老师们都很尽责，把小孩的功课作业教得好以外，更把孩子们的日常也照顾得妥妥当当，让我这在职妈妈可以放心把孩子交给老师👏🏻。老师们也非常注意孩子的品行礼德，赏罚分明，提醒孩子功课&品行都得兼顾🙏🏻👍🏻老师无私的付出，不求回报，不计较，让我倍加感激😘。",
    imageSrc: avatar4.src,
    name: "Elvy Lee",
    username: "@elvy.leeminglie",
  },
  {
    text: "感谢所以卓羿幼儿园的老师把我的3个孩子都教导到很棒 也让我很放心的把孩子交给你们 谢谢老师",
    imageSrc: avatar5.src,
    name: "爱 莲",
    username: "@ai.lian.923",
  },
  {
    text: "Joyee Preschool 有着 1 组年轻有活力的老师和负责人。他们用心尽力地教导和看管，让这些小天使能舒适地学习成长。在课堂上，品行，食物，环境卫生和安全都管理有佳。有必要时，老师们也非常热心地配合家长解决日常上下课的小问题。 Joyee Preschool 也提供了一个比较例外的优势 - 一个比较亲近自然和富有人情的江加埔莱新村环境。在这儿，我要给予 Joyee Preschool 一个赞！感谢大家的努力与付出！",
    imageSrc: avatar6.src,
    name: "Aldrin Ong ",
    username: "@aldrin.ong.96",
  },
  {
    text: "我的两个孩子们3岁就进入这里，现在一个8岁，一个6岁了哦😊我可以很放心的将孩子送到这里上课与托管，谢谢老师们的用心与教导。让我的孩子们能很自律又有礼貌😍老师与家长会有很好的交流与互动，有关孩子们的一些日常问题，都会向家长们述说与纠正孩子们😘年轻的老师们都很棒哦！爱你们😘😘谢谢你们😘😘",
    imageSrc: avatar7.src,
    name: "Emily Toh",
    username: "@toh1121",
  },
  {
    text: "感谢各位老师教导我家的三兄弟,从老大走路跌跌撞撞时就在托管,到一个个顺利毕业,不容易，辛苦了,再次感谢你们细心的照顾😗",
    imageSrc: avatar8.src,
    name: "Wong Pick Huey",
    username: "@pickhuey.wong",
  },
  {
    text: "Joyee Preschool是一間有人情味，有愛心的幼兒園。老師們雖年輕，但她們很用心，很認真的把她們的時間都花在幼兒園，幫家長們教育這些還沒入過學的小豆子們。小豆子們也很享受在這學習的時間，老師們都是用不同的教學來教導。，也讓小豆子們有機會接觸大自然。飲食方面也註重到衛生，健康和營養。我很喜歡我的孩子在這學習。❤❤❤❤❤",
    imageSrc: avatar9.src,
    name: "Zoe Tay",
    username: "@zoe.tay.142",
  },
];
